import { render, staticRenderFns } from "./products.vue?vue&type=template&id=1e6b6b72&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports